import { makeStyles } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';

const useStyles = makeStyles(() => ({
  toggleButton: {
    backgroundColor: '#cbcbcb',
    color: '#555555',
    width: '78px',
    borderColor: '#bfbfbf',
    borderRadius: '12px',

    '&.Mui-selected': {
      backgroundColor: '#898989',
      color: '#ffffff',
    },
  },
}));

interface IProps {
  options: { label: string; value: string }[];
  onChange: (value: string) => void;
  value: string;
}

export const TogglePillsGroup = ({ options, onChange, value }: IProps) => {
  const classes = useStyles();

  return (
    <ToggleButtonGroup
      value={value}
      size="small"
      exclusive
      onChange={(_, selectedValue) => {
        const value = selectedValue === null ? options[0].value : selectedValue;
        onChange(value);
      }}
    >
      {options.map(({ label, value }) => (
        <ToggleButton
          key={value}
          className={classes.toggleButton}
          value={value}
        >
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
